<template>
  <div class="slide zoom" v-parallax-fit="parallax"></div>
</template>

<script>
export default {
  name: 'slide2',
  data() {
    return {
      parallax: [
        {
          start: 0,
          end: 400,
          fromStyle: { transform: 'translateY(0px)' },
          toStyle: { transform: 'translateY(600px)' },
          easing: 'linear',
        },
        {
          start: 800,
          end: 1200,
          fromStyle: { transform: 'translateY(600px)' },
          toStyle: { transform: 'translateY(2400px)' },
          easing: 'linear',
        }
      ]
    };
  }
}
</script>

<style lang="scss" scoped>
.slide {
    position: absolute;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/02_Photo_02.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 470px;
    height: 550px;
    left: -233px;
    top: -400px;
    transition: 0.6s;

    @media(max-width: 600px) {
      top: -380px;
      width: 160px;
      left: -80px;
    }
    @media(max-width: 400px) {
      top: -570px;
    }
}
</style>
